import { Avatar, Button, Divider } from '@heroui/react';
import { Call, Heart, InfoCircle, Receipt21 } from 'iconsax-react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useUser } from '../../../entites/authorization/use-user.ts';

const ListDivider = () => (
  <div className="px-4">
    <Divider className="bg-[#F8F9FA]" />
  </div>
);

export const ShortCuts = () => {
  const { isAuthenticated } = useUser();
  return (
    <>
      <div className="-mx-4">
        {isAuthenticated && (
          <Button
            as={Link}
            to="/orders"
            fullWidth
            size="lg"
            radius="none"
            className="bg-transparent py-4 h-14 max-h-none justify-start  text-[#222222]"
            startContent={
              <Avatar
                className="bg-[#F5F5F5] text-base"
                radius="lg"
                size="md"
                showFallback
                fallback={<Receipt21 size="24" color="#9CA5AC" />}
              />
            }
          >
            История заказов
          </Button>
        )}

        {isAuthenticated && <ListDivider />}

        <Button
          as={Link}
          to="/favorite"
          fullWidth
          size="lg"
          radius="none"
          className="bg-transparent py-4 h-14 max-h-none justify-start  text-[#222222]"
          startContent={
            <Avatar
              className="bg-[#F5F5F5] text-base"
              radius="lg"
              size="md"
              showFallback
              fallback={<Heart size="24" color="#9CA5AC" />}
            />
          }
        >
          Избранное
        </Button>

        <ListDivider />

        <Button
          as={Link}
          to="/notifications"
          fullWidth
          size="lg"
          radius="none"
          className="bg-transparent py-4 h-14 max-h-none justify-start  text-[#222222] hidden"
          startContent={
            <Avatar
              className="bg-[#F5F5F5] text-base"
              radius="lg"
              size="md"
              showFallback
              fallback={
                <Icon
                  className="w-6 h-6 text-[#9CA5AC]"
                  icon="solar:bell-outline"
                />
              }
            />
          }
        >
          Уведомления
        </Button>

        <ListDivider />

        <Button
          as={Link}
          to="/contacts"
          fullWidth
          size="lg"
          radius="none"
          className="bg-transparent py-4 h-14 max-h-none justify-start  text-[#222222]"
          startContent={
            <Avatar
              className="bg-[#F5F5F5] text-base"
              radius="lg"
              size="md"
              showFallback
              fallback={<Call size="20" color="#9CA5AC" />}
            />
          }
        >
          Служба поддержки
        </Button>

        <ListDivider />

        <Button
          as={Link}
          to="/about"
          fullWidth
          size="lg"
          radius="none"
          className="bg-transparent py-4 h-14 max-h-none justify-start  text-[#222222]"
          startContent={
            <Avatar
              className="bg-[#F5F5F5] text-base"
              radius="lg"
              size="md"
              showFallback
              fallback={<InfoCircle size="24" color="#9CA5AC" />}
            />
          }
        >
          О приложении
        </Button>
      </div>
    </>
  );
};
